import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

// Always start a page at the top (browser reloads and in-app navigation).
// Links with a #hash still jump to that section.
if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

export default function ScrollToTop() {
  const { pathname, hash, key } = useLocation();
  useLayoutEffect(() => {
    if (hash) {
      const el = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (el) { el.scrollIntoView(); return; }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash, key]);
  return null;
}
